import { defineComponent as L, mergeModels as C, useModel as w, ref as g, onBeforeMount as M, onMounted as $, openBlock as u, createElementBlock as c, normalizeClass as f, createElementVNode as a, withModifiers as m, renderSlot as k, createCommentVNode as v } from "vue";
import { _ as z } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseComplexToggle.css';const x = ["id", "data-cy"], V = ["data-cy"], H = ["src", "alt"], X = ["innerHTML"], j = ["data-cy"], D = ["src", "alt"], E = ["innerHTML"], N = /* @__PURE__ */ L({
  __name: "BaseComplexToggle",
  props: /* @__PURE__ */ C({
    labels: {},
    type: { default: "full" },
    mode: { default: "" },
    btnBgColor: { default: "uikit-bg-w-lavender" },
    borderContainerColor: { default: "uikit-border-w-secondary" },
    size: { default: "" }
  }, {
    modelValue: {
      default: null
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(d) {
    const l = d, b = w(d, "modelValue"), t = g("uikit-text-white"), o = g(null), s = g(null), i = g(null), n = (e) => {
      !o.value || !s.value || (e === "left-btn" ? (h(), T()) : (p(), y()));
    }, h = () => {
      i.value?.classList.remove("translateX-right"), i.value?.classList.add("translateX-left"), o.value?.classList.add(
        "base-complex-toggle-active",
        t.value
      ), s.value?.classList.remove(
        "base-complex-toggle-active",
        t.value
      );
    }, p = () => {
      i.value?.classList.remove("translateX-left"), i.value?.classList.add("translateX-right"), s.value?.classList.add(
        "base-complex-toggle-active",
        t.value
      ), o.value?.classList.remove(
        "base-complex-toggle-active",
        t.value
      );
    }, T = () => {
      b.value = l.labels.leftToggle;
    }, y = () => {
      b.value = l.labels.rightToggle;
    };
    return M(() => {
      [
        "uikit-bg-w-gray",
        "uikit-bg-w-warning",
        "uikit-bg-w-lavender"
      ].includes(l.btnBgColor) && (t.value = "uikit-text-w-black");
    }), $(() => {
      l.labels.leftToggle.checked ? n("left-btn") : l.labels.rightToggle.checked && n("right-btn");
    }), (e, r) => (u(), c("div", {
      id: e.$attrs.id || "",
      "data-cy": e.$attrs["data-cy"] || "",
      class: f(["base-complex-toggle uikit-relative uikit-flex uikit-justify-center uikit-p-0", [e.mode, e.borderContainerColor, e.size]])
    }, [
      a("div", {
        ref_key: "leftBtn",
        ref: o,
        "data-cy": `bct-left-btn${e.labels.leftToggle.label ? `-${e.labels.leftToggle.label}` : ""}`,
        class: "left-button uikit-flex uikit-flex-1 uikit-items-center uikit-justify-center hover:uikit-cursor-pointer",
        onClick: r[0] || (r[0] = m((B) => n("left-btn"), ["stop"]))
      }, [
        k(e.$slots, "left_icon", {}, () => [
          e.labels.leftToggle.icon ? (u(), c("img", {
            key: 0,
            class: "base-complex-toggle-icon uikit-relative uikit-z-10 uikit-mr-10px",
            src: e.labels.leftToggle.icon.src,
            alt: e.labels.leftToggle.icon.alt,
            width: "15",
            height: "15"
          }, null, 8, H)) : v("", !0)
        ], !0),
        a("span", {
          ref: "leftToggleLabel",
          class: "base-complex-toggle-label uikit-relative uikit-z-10",
          innerHTML: e.labels.leftToggle.label
        }, null, 8, X)
      ], 8, V),
      a("div", {
        ref_key: "rightBtn",
        ref: s,
        "data-cy": `bct-right-btn${e.labels.rightToggle.label ? `-${e.labels.rightToggle.label}` : ""}`,
        class: "right-button uikit-flex uikit-flex-1 uikit-items-center uikit-justify-center hover:uikit-cursor-pointer",
        onClick: r[1] || (r[1] = m((B) => n("right-btn"), ["stop"]))
      }, [
        k(e.$slots, "right_icon", {}, () => [
          e.labels.rightToggle.icon ? (u(), c("img", {
            key: 0,
            class: "base-complex-toggle-icon uikit-relative uikit-z-10 uikit-mr-10px",
            src: e.labels.rightToggle.icon.src,
            alt: e.labels.rightToggle.icon.alt,
            width: "15",
            height: "15"
          }, null, 8, D)) : v("", !0)
        ], !0),
        a("span", {
          ref: "rightToggleLabel",
          class: "base-complex-toggle-label uikit-relative uikit-z-10",
          innerHTML: e.labels.rightToggle.label
        }, null, 8, E)
      ], 8, j),
      a("div", {
        ref_key: "dynamicBg",
        ref: i,
        class: f(["uikit-absolute uikit-transition-all uikit-duration-200 uikit-ease-out", [
          e.type === "full" ? "base-complex-toggle-active-bg" : "base-complex-toggle-active-padded-bg",
          e.btnBgColor,
          e.mode
        ]])
      }, null, 2)
    ], 10, x));
  }
}), A = /* @__PURE__ */ z(N, [["__scopeId", "data-v-ced63d8c"]]);
export {
  A as default
};
